import styled, { css } from 'styled-components';

export const Section = styled.div`
  padding-top: 72px;
  padding-bottom: 100px;

  @media (max-width: 900px) {
    padding-top: 32px;
    padding-bottom: 80px;
  }
`;

export const Container = styled.div`
  width: 100%;
  padding-right: 32px;
  padding-left: 32px;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 576px) {
    width: 540px;
  }

  @media (min-width: 768px) {
    width: 720px;
  }

  @media (min-width: 992px) {
    width: 960px;
  }

  @media (min-width: 1200px) {
    width: 1140px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    margin-top: 72px;

    font-size: 40px;
    font-weight: 600;
    line-height: 56px;

    text-align: center;
    color: ${theme.colors.blueEinstein};

    @media (max-width: 900px) {
      font-size: 32px;
      line-height: 40px;
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    max-width: 500px;
    margin-top: 24px;
    margin-bottom: 64px;

    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0;
    color: #898b8e;
    text-align: center;

    a {
      color: ${theme.colors.blueEinstein};
    }
  `}
`;
